import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getQuestion } from './actions';
import './style.scss';
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent';

import classNames from 'classnames';
import Question from './components/Question/Question';
import List from './components/List/List';
import { Result } from 'antd';
import Header from './components/Header/Header';

export class QuestionView extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      questions: [],
      answers: {},
      activeQuestion: 0
    }
  }

  async componentDidMount(){
    const {questions, category} = await getQuestion(this.props.match.params.id);

    if(category){
      document.title = category.name;
    }

    this.setState({
      loaded: true,
      questions,
      activeQuestion: questions[0]['id']
    })
  }

  changeAnswer = (value) => {
    const {answers} = this.state;
    this.setState({answers: {...answers, ...value}})
  }

  render() {
    const {questions, answers, activeQuestion, loaded} = this.state;
    const {formatMessage} = this.props;

    if(!loaded){
      return null;
    }

    if(questions.length == 0){
      return <Result
      status="500"
      title={formatMessage('titleNotFoundQwestion')}
      subTitle={formatMessage('msgNotFoundQwestion')}
    />
    }
    const question = questions.find(_i => activeQuestion == _i.id)
    return (<div className='QuestionViewBlock'>
      <List 
        onChange={(v) => this.setState({activeQuestion: v})} 
        questions={questions}
        activeQuestion={activeQuestion}
        answers={answers}
      />
      <div className='block-content'>
        <Header formatMessage={formatMessage} questions={questions} answers={answers} onReset={() => {
          this.setState({answers: {}})
        }}/>
        <Question activeQuestion={activeQuestion} question={question} formatMessage={formatMessage} answersUser={answers} changeAnswer={this.changeAnswer} />
      </div>
    </div>)
  }
}

export default WrappedIntlComponent(QuestionView)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionView/QestionView.jsx